import images from "../../../Utils/Images";

export const portfolioData = [
  {
    id: 'projects',
    category: 'Our Projects',
    description: 'We build scalable, secure, and user-friendly web applications tailored to your business needs.',
    projects: [
      {
        id: 'proj-1',
        title: 'Enterflow Task Management',
        description: 'A modern Task management platform that was built for daily routines and events management.',
        image: images.portfolio,
      },
      {
        id: 'proj-2',
        title: 'E-commerce Platform',
        description: 'A high-performance online store built with microservices architecture for scalability.',
        image: images.portfolio,
      },
      {
        id: 'proj-3',
        title: 'Data Visualization Dashboard',
        description: 'An interactive dashboard for real-time analysis of business metrics.',
        image: images.portfolio,
      },
      {
        id: 'proj-4',
        title: 'Custom CRM Solution',
        description: 'A tailored Customer Relationship Management system for B2B sales pipelines.',
        image: images.portfolio,
      },
      {
        id: 'proj-5',
        title: 'Online Learning Portal',
        description: 'A comprehensive platform offering video courses and interactive quizzes.',
        image: images.portfolio,
      },
    ],
  }];